import React from 'react';
import { useState } from 'react';
import MonitoringReportDashboard from './MonitoringReportDashboard';
import IncidentListing from './IncidentListing';
import TimeTracker from './TimeTracker';
import { PageBody } from '../../components/SiteWrapper';

import TabLayout from '../../components/TabUI/TabLayout';

const ParentMinistryReportPage = () => {
  const tabData = [
    {
      label: 'Dashboard',
      content: <MonitoringReportDashboard />,
    },
    {
      label: 'Incidents',
      content: <IncidentListing />,
    },
    {
      label: 'Time Tracker',
      content: <TimeTracker />,
    },
  ];

  return (
    <div>
      <TabLayout tabs={tabData} defaultIndex={0} />
    </div>
  );
};

export default ParentMinistryReportPage;
